var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 40,
    viewBox: "0 0 54 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"Bar Chart\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.5908 29.9483H43.912C44.5753 29.9483 45.2385 29.2851 45.2385 28.6219V4.74604C45.2385 4.08282 44.5753 3.4196 43.912 3.4196H41.5908C40.9276 3.4196 40.2643 4.08282 40.2643 4.74604V28.6219C40.2643 29.2851 40.9276 29.9483 41.5908 29.9483ZM21.6943 29.9483H24.0155C24.6787 29.9483 25.342 29.2851 25.342 28.6219V8.06212C25.342 7.3989 24.6787 6.73569 24.0155 6.73569H21.6943C21.031 6.73569 20.3678 7.3989 20.3678 8.06212V28.6219C20.3678 29.2851 21.031 29.9483 21.6943 29.9483ZM31.6425 29.9483H33.9638C34.627 29.9483 35.2902 29.2851 35.2902 28.6219V14.6943C35.2902 14.0311 34.627 13.3679 33.9638 13.3679H31.6425C30.9793 13.3679 30.3161 14.0311 30.3161 14.6943V28.6219C30.3161 29.2851 30.9793 29.9483 31.6425 29.9483ZM51.8706 34.9224H5.44544V1.76156C5.44544 0.84549 4.70347 0.103516 3.7874 0.103516H2.12936C1.21329 0.103516 0.471313 0.84549 0.471313 1.76156V36.5805C0.471313 38.4116 1.9563 39.8965 3.7874 39.8965H51.8706C52.7867 39.8965 53.5287 39.1546 53.5287 38.2385V36.5805C53.5287 35.6644 52.7867 34.9224 51.8706 34.9224ZM11.746 29.9483H14.0673C14.7305 29.9483 15.3937 29.2851 15.3937 28.6219V21.3265C15.3937 20.6632 14.7305 20 14.0673 20H11.746C11.0828 20 10.4196 20.6632 10.4196 21.3265V28.6219C10.4196 29.2851 11.0828 29.9483 11.746 29.9483Z",
    fill: "#419788"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.7ec24556bd710f2920ab570502fbfde2.svg";
export { ForwardRef as ReactComponent };